<div style="display: flex; align-items: center; gap: 6px;">

    <!-- ===== Assets page: terminal icon + Actions dropdown ===== -->
    <ng-container *ngIf="displayActions">
        <button class="ab-icon-btn" [disabled]="!assetsDebugRight()"
                (click)="openCommandPrompt()"
                matTooltip="Command Terminal" matTooltipPosition="below">
            <fa-icon [icon]="faTerminal"></fa-icon>
        </button>

        <button class="ab-dropdown-trigger" [matMenuTriggerFor]="deviceActionsMenu">
            <mat-icon class="ab-dropdown-icon">tune</mat-icon>
            <span>Actions</span>
            <mat-icon class="ab-dropdown-chevron">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #deviceActionsMenu="matMenu">
            <button mat-menu-item [disabled]="!assetssetWifiRight()" (click)="setWifi()">
                <mat-icon>wifi</mat-icon><span>WiFi Configuration</span>
            </button>
            <button mat-menu-item [disabled]="!assetsrebootRight()" (click)="onReboot()">
                <mat-icon>restart_alt</mat-icon><span>Reboot / Reset</span>
            </button>
            <button mat-menu-item [disabled]="!assetsresetAPNRight()" (click)="setApn()">
                <mat-icon>cell_tower</mat-icon><span>Set APN</span>
            </button>
            <button mat-menu-item *ngIf="assetsresetCPNRight()" (click)="setCpin()">
                <mat-icon>lock</mat-icon><span>Set CPIN</span>
            </button>
            <button mat-menu-item (click)="advnceConfig()">
                <mat-icon>settings_screen</mat-icon><span>Advance Configurations</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item [disabled]="!assetsaddDeviceRight()" (click)="addDevice()">
                <mat-icon>add_circle_outline</mat-icon><span>Add Device</span>
            </button>
            <button mat-menu-item [disabled]="!assetsdeleteRight()" (click)="delete()" class="ab-menu-item-danger">
                <mat-icon>delete_outline</mat-icon><span>Delete</span>
            </button>
        </mat-menu>
    </ng-container>

    <!-- ===== Live Walk Test: config icon + Ping + Ongoing Tests + Stop/Start + map dropdown ===== -->
    <ng-container *ngIf="walktestActions">
        <button class="ab-icon-btn" [disabled]="!liveWalkTest()"
                (click)="openTestConfigurations()"
                matTooltip="Test Configurations" matTooltipPosition="below">
            <img style="pointer-events: none; max-width: 18px;" src="/assets/svgs/configsettings.svg" alt="config" />
        </button>

        <button *ngIf="!hidePingButton" class="btn btn-primary truncated" [disabled]="!liveWalkTest() || !deviceStatus || !selectedDevice?.[0]"
                (click)="openCommandPrompt()">Ping</button>

        <button class="btn btn-primary truncated" [disabled]="!liveWalkTest()"
                (click)="openOnGoing()">Ongoing Tests</button>

        <button class="btn btn-primary truncated" [disabled]="!liveWalkTest()"
                (click)="stopTest()">Stop Test</button>

        <button class="btn btn-primary truncated"
                [disabled]="disableWalktestActions || !selectedMap?.[0] || !selectedDevice?.[0] || !liveWalkTest()"
                (click)="startTest()">Start Test</button>

        <div class="multi-select-angular position-relative" style="margin-right: 6px; width: 150px;" *ngIf="!isDetailedReport">
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas add_map_direction" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="walktestMaplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event, true)">
                <c-item>
                    <ng-template let-item="item">
                        <div *ngIf="item.isHeader; else normalItem" (click)="onAddNewMap()" class="custom-add-map">
                            <strong style="color: #007bff; cursor: pointer;">+ Add New Map</strong>
                        </div>
                        <ng-template #normalItem>
                            <label>{{ item.name }}</label>
                        </ng-template>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
            <div class="position-absolute translate-middle" style="right: 1%; top: 40%">
                <div *ngIf="loadMaps" class="loader"></div>
            </div>
        </div>
    </ng-container>


 <!-- // walktest scheduler device dropdown -->
    <ng-container *ngIf="pageName=='Test Scheduler' || pageName=='Security Test Scheduler'">
        <div style="margin-right: 6px;">
            <button  class="btn btn-primary" [disabled]="disableWalktestActions || !walktestSchduler()"
                (click)="startTest()">Schedule Test</button>
        </div>

        <div class="multi-select-angular" style="margin-right: 6px;  width: 150px;display:none" *ngIf="!isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 2</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
    </ng-container>

    <ng-container *ngIf="pageName=='Detailed Report'||pageName=='Device Locator'">
        <div style="margin-right: 6px;" *ngIf="pageName!='Device Locator'" >
            <button  class="btn btn-primary" [disabled]="disableDetailedSubmit"
                (click)="handleDetailedReport()">Submit</button>
        </div>

        <div class="multi-select-angular" style="margin-right: 6px; width: 150px;" *ngIf="!isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 3</label> -->
             <!-- device locator map dropdown -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
    </ng-container>


    <ng-container *ngIf="pageName =='MNO Mapping'">
        
            <div style="text-align: end;padding: 0px;margin-right: 10px;">
                <button  class="btn btn-primary"  [disabled]="!mnoMapping()"
                    (click)="openConfigureModal()">Configure MNO <i class="fa fa-gear"
                        ></i></button>
            </div>
            <div style="text-align: end;padding: 0px;margin-right: 0px;">
                <button  class="btn btn-primary" data-toggle="modal" [disabled]="!mnoMapping()"
                    (click)="OpenMNOAddPopup()" data-target="#exampleModalCenter">New MNO Map <i class="fa fa-plus"
                        aria-hidden="true"></i></button>
            </div>
      
    </ng-container>
    <ng-container *ngIf="pageName =='Floor Maps Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!floorMapsManager()"
                (click)="OpenPopup('html')">Add Map
                +</button>
        </div>
        <div style="text-align: end;padding: 0px;margin-right: 0px;">

            <button type="button" (click)="openImportPopup()" class="btn btn-primary" [disabled]="!floorMapsManager()"
                style="margin-right: 20px;">Import
                from CSV</button>
        </div>
    </ng-container>
    <ng-container *ngIf="pageName =='Groups Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!groupsManager()"
                (click)="OpenPopupNewGroup()">New
                Group <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <ng-container *ngIf="pageName =='Roles Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!rolesManager()"
                (click)="OpenPopupNewProfile()">New
                Profile <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <ng-container *ngIf="pageName =='Users Manager'">
        <div style="text-align: end;padding: 0px;margin-right: 0px;">
            <button type="button" class="btn btn-primary" style="margin-right: 20px;" [disabled]="!usersManager()"
                (click)="OpenPopupNewUser()">New
                User <i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>


    </ng-container>
    <!-- <div *ngIf="imeiDropdown" style="margin-right: 6px; font-size: 12px; position: relative; top: 10px;">
        <label name="label-imei" id="label-imei">IMEI Number</label>
    </div> -->
    <!-- ===== Security Test Results: Apply + rule-id + profile multi-select ===== -->
    <ng-container *ngIf="pageName == 'Security Test Results'">
        <button class="btn btn-primary" style="margin-right: 6px;" (click)="onSecurityApply()">Apply</button>
        <div class="multi-select-angular ab-device-select" style="margin-right: 6px; min-width: 200px;">
            <angular2-multiselect name="multiselect-security-rules" id="multiselect-security-rules"
                class="hide_checkbox-select data_modelClas large-text-handle"
                [settings]="multipleSettingsSecurityRuleId"
                [data]="securityRuleIdOptions"
                [(ngModel)]="selectedSecurityRuleIds"
                (onSelect)="onRuleIdSelect($event)"
                (onDeSelect)="onRuleIdDeSelect($event)"
                (onSelectAll)="onRuleIdSelectAll($event)"
                (onDeSelectAll)="onRuleIdDeSelectAll()">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
        <div class="multi-select-angular ab-device-select" style="margin-right: 6px; min-width: 230px;">
            <angular2-multiselect name="multiselect-security-profiles" id="multiselect-security-profiles"
                class="hide_checkbox-select data_modelClas large-text-handle"
                [settings]="multipleSettingsSecurityProfile"
                [data]="securityProfileOptions"
                [(ngModel)]="selectedSecurityProfiles"
                (onSelect)="onProfileSelect($event)"
                (onDeSelect)="onProfileDeSelect($event)"
                (onSelectAll)="onProfileSelectAll($event)"
                (onDeSelectAll)="onProfileDeSelectAll()">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.label}}</label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
    </ng-container>

<div *ngIf="pageName =='GPS Report' || currentUrl=='/gps-report'"> 
    <button mat-raised-button class="btn-primary mr-2" name="generateReport" id="generateReport" (click)="generateReport()">Generate Report</button>
</div>
    <div *ngIf="eventTypeShow" style="margin-right: 6px;">
        <button  class="btn btn-primary" (click)="handleNotificationSubmit()">Submit</button>
    </div>
    <div *ngIf="eventTypeShow" class="multi-select-angular" style="margin-right: 6px;">
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number</label> -->
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number</label> -->
        <!-- {{devices}} -->
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 4</label> -->
        <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
            class="hide_checkbox-select data_modelClas" [data]="eventTypes" [(ngModel)]="selectedEventType"
            (onSelect)="changeEventType($event)" [settings]="multipleSettings3">
            <c-item>
                <ng-template let-item="item">
                    <label>{{item.type_name }}</label>
                </ng-template>
            </c-item>
        </angular2-multiselect>

    </div>
    <!-- // global Notifications   not used--> 
    <div *ngIf="eventTypeShow" class="multi-select-angular" style="margin-right: 6px;">
        <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 5</label> -->
        <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
            class="hide_checkbox-select data_modelClas" [data]="notificationDevices"
            [(ngModel)]="selectedNotificationDevice" [settings]="multipleSettings5">
            <c-item>
                <ng-template let-item="item">
                    <label>{{item.deviceid}} ({{item.name}})</label>
                </ng-template>
            </c-item>
        </angular2-multiselect>
    </div>
    <div *ngIf="redirectAction && !showBackButton" style="margin-right: 10px; font-size: 12px;">
        <button  class="btn btn-primary" 
            (click)="goToTAssets('Telemetry')">Go to Assets</button>
    </div>
    <div *ngIf="redirectAction && !showBackButton" style="margin-right: 10px; font-size: 12px;">
        <button  class="btn btn-primary" 
            (click)="goToWalktest('Telemetry')">Go to Active Test</button>
    </div>

    <!--walktest, scheduler,  telemetry, device Configuration, Device Locator, video stream,  edge intelligence, data model-->
    <div *ngIf="imeiDropdown&&!isDetailedReport" class="multi-select-angular ab-device-select" style="margin-right: 6px;min-width: 230px !important;">
        <ng-select
            [items]="devices"
            bindLabel="serial_name"
            [virtualScroll]="true"
            [(ngModel)]="selectedDeviceSingle"
            (ngModelChange)="ChangeDevice()"
            [disabled]="disableWalktestActions"
            class="hide_checkbox-select data_modelClas large-text-handle"
            id="multiselect-devices"
            name="multiselect-devices"
            placeholder="Select An Serial Number">
            <ng-template ng-option-tmp let-item="item">
                <div style="display:flex; align-items:center; gap:4px; overflow:hidden;">
                    <span style="flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                          [title]="item.serial_name">
                          {{item.serial_name}}
                          <span *ngIf="item.isStandalone" class="badge text-bg-secondary">Standalone</span>
                    </span>
                    <span *ngIf="!item.isStandalone" style="flex-shrink:0;"><fa-icon [icon]="faInfoCircle" (click)="handleBandInfoCHeck($event,item)"></fa-icon></span>
                </div>
            </ng-template>
        </ng-select>
    </div>

    <div class="position-relative">
        <!-- // walktest detailed Report -->
        <div *ngIf="imeiDropdown&&isDetailedReport" class="multi-select-angular" style="margin-right: 6px; min-width: 210px !important;">
            <ng-select
                [items]="devicesReprt"
                bindLabel="serial_name"
                [virtualScroll]="true"
                [(ngModel)]="selectedReportDeviceSingle"
                (ngModelChange)="ChangeDevice()"
                class="hide_checkbox-select data_modelClas large-text-handle"
                id="multiselect-devices"
                name="multiselect-devices"
                placeholder="Select An Serial Number">
                <ng-template ng-option-tmp let-item="item">
                    <span style="display:block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                          [title]="item.serial_name">
                        {{item.serial_name}}
                        <span *ngIf="item.isStandalone" class="badge text-bg-secondary">Standalone</span>
                        <fa-icon *ngIf="item?.isWifi" [icon]="faWifi" class="ml-1"></fa-icon>
                    </span>
                </ng-template>
            </ng-select>
        </div>
        <div class="position-absolute translate-middle " style="right: 1%; top:40%" >
            <div *ngIf="fetchingDevices" class="loader"></div>
        </div>
     </div>

    <div class="position-relative">
        <div class="multi-select-angular" style=" width: 150px; " *ngIf="isDetailedReport">
            <!-- <label name="label-imei" id="label-imei" class="m-0">IMEI Number 8</label> -->
            <angular2-multiselect name="multiselect-devices" id="multiselect-devices"
                class="hide_checkbox-select data_modelClas" [settings]="multipleSettings2" [lazyLoading]="true"
                [data]="maplist" [(ngModel)]="selectedMap" (ngModelChange)="changeMap($event)">
                <c-item>
                    <ng-template let-item="item">
                        <label>{{item.name}} <span *ngIf="item?.isWifi"  ><fa-icon [icon]="faWifi" ></fa-icon></span></label>
                    </ng-template>
                </c-item>
            </angular2-multiselect>
        </div>
        <div class="position-absolute translate-middle " style="right: 1%; top:40%" >
            <div *ngIf="fetchingMaps" class="loader"></div>
        </div>
     </div>


</div>

<app-modal [showPopup]="openBandlockInfo" name="create">

    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabeldevice">Bandlock information</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeBandlockInfo()" >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="p-2">
            <table class="text-start ">
                <tbody>
                  <tr>
                    <td class="p-2 font-weight card-left-text">Device</td>
                    <td class="card-width pr-2">:</td>
                    <td>{{deviceDetails?.deviceid}} ({{deviceDetails?.name}})</td>
                  </tr>
                  <tr>
                    <td class="p-2 font-weight card-left-text">Device Status</td>
                    <td class="card-width pr-2">:</td>
                    <td>
                        <span id="param-value" name="param-value"
                        *ngIf="deviceStatusInfo === 'online';"
                        class="badge bg-success">Online</span>
                    <span id="param-value" name="param-value"
                        *ngIf="deviceStatusInfo === 'offline';"
                        class="badge bg-danger">Offline</span>
                    </td>
                  </tr>


            
                  </tbody>
                  </table>
        </div>
        <!-- (selectedTabChange)="onTabChange('html',$event)" [(selectedIndex)]="selectedTabIndex"  -->
        <mat-tab-group >
            <mat-tab *ngFor="let tab of sliceModems; let index = index;" [label]="tab.imei"
            [id]="tab.imei+index" [name]="tab.imei+index">
            <ng-template mat-tab-label>
                <div>{{tab.modem_name}}</div> 
                <div>{{tab.imei}}</div>
            </ng-template>
            <ng-template matTabContent>

         <div class="p-2">
            <p class="mt-1 mb-1">Applied MNO Map : <span *ngFor="let item of tab.template_names"> {{item}}</span></p>
            <p class="location-design fw-bold mt-2"> <span class="supported-dot"></span> SUPPORTED BANDS</p>

            <tabset>
                <!-- <tab [heading]="'3G'" [active]=true (selectTab)=false>
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let threeg of tab?.band_info?.SUPPORTED_BAND_3G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{threeg}}</span>
                        </span>
                    </div>
                </tab> -->
                <tab [heading]="'4G'" [active]="selectedTab === '4G'" (selectTab)="selectedTab = '4G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let fourg of tab?.band_info?.SUPPORTED_BAND_4G"> -->
                            <!-- <span class="badge rounded-pill bg-info  m-1 p-2">{{fourg}}</span>
                        </span> -->
                        <span *ngFor="let fourg of tab?.band_info?.SUPPORTED_BAND_4G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_4G?.includes(fourg),
                                'bg-info': !tab?.band_info?.BAND_4G?.includes(fourg)
                              }">
                              {{fourg}}
                            </span>
                          </span>
                    </div>
                </tab>
                <tab [heading]="'5G'"  [active]="selectedTab === '5G'" (selectTab)="selectedTab = '5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_5G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{fiveg}}</span>
                        </span> -->
                        <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_5G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_5G?.includes(fiveg),
                                'bg-info': !tab?.band_info?.BAND_5G?.includes(fiveg)
                              }">
                              {{fiveg}}
                            </span>
                          </span>
                    </div>
                </tab>
                <tab [heading]="'NR5G'"  [active]="selectedTab === 'NR5G'" (selectTab)="selectedTab = 'NR5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <!-- <span *ngFor="let nsag of tab?.band_info?.SUPPORTED_BAND_NSA_5G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{nsag}}</span>
                        </span> -->
                        <span *ngFor="let fiveg of tab?.band_info?.SUPPORTED_BAND_NSA_5G">
                            <span 
                              class="badge rounded-pill m-1 p-2"
                              [ngClass]="{
                                'bg-success': tab?.band_info?.BAND_NSA_5G?.includes(fiveg),
                                'bg-info': !tab?.band_info?.BAND_NSA_5G?.includes(fiveg)
                              }">
                              {{fiveg}}
                            </span>
                          </span>

                    </div>
                </tab>
            </tabset>
        </div>
        <hr style="border: 1px solid grey;">
        <div>
            <p class="location-design fw-bold"> <span class="green-dot"></span> LOCKED BANDS</p>
            <tabset>
                <!-- <tab [heading]="'3G'" [active]=true (selectTab)=false>
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locthreeg of tab?.band_info?.BAND_3G">
                            <span class="badge rounded-pill bg-info  m-1 p-2">{{locthreeg}}</span>
                        </span>
                    </div>
                </tab> -->
                <tab [heading]="'4G'" [active]="selectedTab === '4G'" (selectTab)="selectedTab = '4G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locfourg of tab?.band_info?.BAND_4G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locfourg}}</span>
                        </span>
                    </div>
                </tab>
                <tab [heading]="'5G'"  [active]="selectedTab === '5G'" (selectTab)="selectedTab = '5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locfiveg of tab?.band_info?.BAND_5G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locfiveg}}</span>
                        </span>
                    </div>
                </tab>
                <tab [heading]="'NR5G'"   [active]="selectedTab === 'NR5G'" (selectTab)="selectedTab = 'NR5G'">
                    <div style="height: 100px;overflow-y: auto;">
                        <span *ngFor="let locnsag of tab?.band_info?.BAND_NSA_5G">
                            <span class="badge rounded-pill bg-success  m-1 p-2">{{locnsag}}</span>
                        </span>
                    </div>
                </tab>
            </tabset>
        </div>
</ng-template>
        </mat-tab>
        </mat-tab-group>
    </div>
    <div class="modal-footer"> 
        <button type="button" class="btn btn-danger"    (click)="closeBandlockInfo()">Close</button>
        <!-- <button type="button" class="btn btn-primary" >Previous</button> -->
    </div>

</app-modal>